var $ = jQuery.noConflict ();
var $window = jQuery (window);

var rtime;
var timeout = false;
var delta = 200;
var parallaxrunset = 0;
var pagePos = 0;

jQuery (window).on ('resize', function (){
    rtime = new Date ();
    if (timeout === false) {
        timeout = true;
        setTimeout (resizeend, delta);
    }
});

/*
 * Add your functions triggered after resize end
 */
function resizeend(){
    if (new Date () - rtime < delta) {
        setTimeout (resizeend, delta);
    } else {
        timeout = false;

        // GRID HELPER
        screenSize ()

        /* Make #content padding top whene use fixed menu - engine.js */
        fixedTopForHeader ();

        /* Bootstrap -  set same height for all .col* in .row-eq-height - engine.js */
        rowEQheight ();

        /* Bootstrap - full width element .full_width_element when use container for all page */
        fullWidthElement ();

    }
}


function addTitleInDropdown(){
    //This function get title from first Depth menu item and add in dropdown menu in second depth


    var title = false;
    var dropdown = false;
    var submenu = false;
    var titleClone = false;

    var li = $ ('#header .menu-top > .menu-item');
    li.each (function (){
        title = $ (this).children ('a').find ('span').text ();
        titleClone = $ (this).children ('a').find ('span').clone ();
        titleClone.addClass ('clone-bold');

        $ (this).children ('a').append (titleClone);

        if (title.length > 0) {
            dropdown = $ (this).find ('ul.dropdown-menu');
            if (dropdown.length > 0) {
                submenu = dropdown.html ();
                dropdown.html ('<li class="title h3"></li><li class="nav"><ul></ul></li>');
                $ (this).find ('li.title').text (title);
                $ (this).find ('li.nav ul').html (submenu);
            }

        }
        submenu = false;
        title = false;
        dropdown = false;
    });

}

function topRightMenuHoverEffect(){
    //This function get title from first Depth menu item and add in dropdown menu in second depth


    var titleClone = false;

    var li = $ ('#header .menu-top-right > .menu-item ');
    li.each (function (){
        titleClone = $ (this).children ('a').find ('span').clone ();
        titleClone.addClass ('clone-bold');

        $ (this).children ('a').append (titleClone);

    });

}

function addCloseBtn(){
    var li = $ ('#header .menu-top > .menu-item-has-children');
    var dropdown;
    li.each (function (){
        dropdown = $ (this).find ('ul.dropdown-menu').append ('<button class="close-submenu-btn d-block d-xl-none"><svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M12 0c6.623 0 12 5.377 12 12s-5.377 12-12 12-12-5.377-12-12 5.377-12 12-12zm0 1c6.071 0 11 4.929 11 11s-4.929 11-11 11-11-4.929-11-11 4.929-11 11-11zm0 10.293l5.293-5.293.707.707-5.293 5.293 5.293 5.293-.707.707-5.293-5.293-5.293 5.293-.707-.707 5.293-5.293-5.293-5.293.707-.707 5.293 5.293z"/></svg></button>');

    });

}

function displayItemInDropdownMenu(){
    //This function get title from first Depth menu item and add in dropdown menu in second depth

    var nav;
    var featuredImage;
    var li;

    li = $ ('#header .menu-top > .menu-item');

    li.each (function (){
        nav = $ (this).find ('li.nav');
        featuredImage = nav.find ('.featured-img');

        if ( !featuredImage.length > 0) {
            nav.children ().addClass ('column-direction');
        }
    });

}

function scrollEffect(){
    var wWindow = jQuery (window).width ();
    var hWindow = jQuery (window).height ();
    var posBody = jQuery ("body").scrollTop ();
    var posHtml = jQuery ("html").scrollTop ();
    var posHtml = jQuery ("html").scrollTop ();

    var pos = 0;

    if (posBody > 0) pos = posBody;
    if (posHtml > 0) pos = posHtml;

    if (posHtml > 80 || posBody > 80) {
        jQuery ("body").addClass ("scrolled");
        jQuery ("#header").addClass ("scrolled");
    } else {
        jQuery ("body").removeClass ("scrolled");
        jQuery ("#header").removeClass ("scrolled");
    }

    pagePos = pos;
}

function burgerMenu(){
    $ ('#burger-icon').click (function (){
        $ (this).toggleClass ('open');
        $ ('#header .content-menu-wrapper').toggleClass ('open');
        $ ('body').toggleClass ('freeze');

    });
}

function scrollToTop(){
    $ ('.scroll-to-top-btn').on ('click', function (){
        backToTop ();
    })
}

function bootstrapMenuHover(){
    const $dropdown = $ ("#header .dropdown, #header .menu-item");
    const $dropdownToggle = $ ("#header .dropdown-toggle");
    const $dropdownMenu = $ ("#header .dropdown-menu");
    const showClass = "show";

    $ (window).on ("load resize", function (){
        if (this.matchMedia ("(min-width: 1200px)").matches) {

            $dropdown.mouseover(function (){
                const $this = $ (this);
                $this.addClass (showClass);
                $this.find ($dropdownToggle).attr ("aria-expanded", "true");
                $this.find ($dropdownMenu).addClass('show');
            });
            $dropdown.mouseleave(function (){
                const $this = $ (this);
                $this.removeClass (showClass);
                $this.find ($dropdownToggle).attr ("aria-expanded", "false");
                $this.find ($dropdownMenu).removeClass('show');
            });
        } else {
            $dropdown.off ("mouseenter mouseleave");
        }
    }); 
}

function newsletterMailchimpConnect(){

    $ ("#newsletter").submit (function (event){

        var infoBox = $ ('#footer .info-box');

        $.ajax ({
            type: "GET",
            url: acme_ajax_object.ajax_url,
            data: 'action=newsletter_mailchimp&security=' + acme_ajax_object.security + '&' + $ ('form#newsletter').serialize (),
            success: function (data){

                var json = JSON.parse (data);

                if (json.status == 'subscribed') {
                    var successText = $ ('#newsletter').data ('success');
                    infoBox.text (successText);
                    infoBox.slideDown ();
                    setTimeout (function (){
                        infoBox.slideUp ();
                        infoBox.text ('');
                    }, 5000);
                }

                if (json.status == 400) {
                    var failedText = $ ('#newsletter').data ('failed');
                    infoBox.text (failedText);
                    infoBox.slideDown ();

                    setTimeout (function (){
                        infoBox.slideUp ();
                        infoBox.text ('');
                    }, 5000);
                }
            },
            error: function (errorThrown){
            }
        });

        event.preventDefault ();
    });
}

function video(){
    $ ('.vimeo-container:not(.init)').each (function (){
        $ (this).addClass ('init')
        var id = $ (this).attr ('id');
        var options = {
            width: 690,
            loop: false,
            responsive: true
        };
        $ (this).closest ('.video__iframe').find ('.video__play').on ('click', function (){
            var videoPlayer = new Vimeo.Player (id, options);
            $ (this).closest ('.video__iframe').find ('.video__poster').fadeOut ();
            $ (this).closest ('.video__iframe').addClass('video-played');
            $ (this).fadeOut ();
            videoPlayer.play ();
        });
    })
}




/*
 * Add your functions triggered after page ready
 */
jQuery (document).ready (function (){

    $(".footer-nav .menu-item-has-children > a").replaceWith(function(){
        return $("<span>" + $(this).html() + "</span>");
    });

    //grid helpers
    screenSize ();
    showGridLines();

    /* animated burger icon mobile*/
    jQuery (".navbar-toggle").on ("click", function (){
        jQuery (this).toggleClass ("active");
    });
    bootstrapMenuHover ();
    burgerMenu ();
    /* Make #content padding top whene use fixed menu - engine.js */
    // fixedTopForHeader();

    /* Bootstrap - scroll to colapsed element in acordeon - engine.js */
    scrollToColapsedElement ();

    /* Bootstrap - on hover show (slide) submenu - engine.js */
    toggleNavbarMethod ();

    /* Bootstrap - scroll to colapsed element in acordeon - engine.js */
    scrollToColapsedElement ();

    $ (document).scroll (function (){
        scrollEffect ();
    });

    addTitleInDropdown ();
    displayItemInDropdownMenu ();
    topRightMenuHoverEffect ();
    addCloseBtn ();
    scrollToTop ();
    newsletterMailchimpConnect ();
    video ();
});

/*
 * Add your functions triggered after all media and page loaded
 */
jQuery (window).on ('load', function (){


    lighboxInit ();

    /* trigger resize to recomposition element after load */
    jQuery (window).trigger ('resize');


});

/* Global - scroll page to TOP */
function backToTop(){
    jQuery ("html, body").animate ({ scrollTop: 0 }, 1000);
}
